import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const toBase64 = async (url) => {
    const res = await fetch(url, { mode: 'cors' });
    const blob = await res.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export const pdfblobURL = async (html, fileName) => {

    const logoBase64 = await toBase64(
        window.location.origin + "/shipez-logo.png"
    );

    html = html.replace(
        "http://app.shipez.ai/shipez-logo.png",
        logoBase64
    );

    // Hidden iframe render
    const iframe = document.createElement("iframe");

    iframe.style.position = "absolute";
    iframe.style.left = "-9999px";
    iframe.style.width = "1024px";

    document.body.appendChild(iframe);

    iframe.contentDocument.open();
    iframe.contentDocument.write(html);
    iframe.contentDocument.close();

    const element = iframe.contentDocument.body;

    const canvas = await html2canvas(element, {
        scale: 1.5,              // quality vs size balance
        useCORS: true,
        backgroundColor: "#ffffff",
        windowWidth: 1024,
        allowTaint: false
    });

    // Use JPEG instead PNG (major size reduction)
    const imgData = canvas.toDataURL(
        "image/jpeg",
        0.75                 // compression quality
    );

    // Compressed PDF
    const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
        compress: true
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgProps = pdf.getImageProperties(imgData);

    const imgWidth = pdfWidth;

    const imgHeight =
        (imgProps.height * imgWidth) /
        imgProps.width;

    let heightLeft = imgHeight;

    let position = 0;

    // First page
    pdf.addImage(
        imgData,
        "JPEG",
        0,
        position,
        imgWidth,
        imgHeight,
        undefined,
        'FAST'
    );

    heightLeft -= pdfHeight;

    // Multi pages
    while (heightLeft > 0) {

        position = heightLeft - imgHeight;

        pdf.addPage();

        pdf.addImage(
            imgData,
            "JPEG",
            0,
            position,
            imgWidth,
            imgHeight,
            undefined,
            'FAST'
        );

        heightLeft -= pdfHeight;
    }

    // Convert to blob
    const pdfBlob = pdf.output("blob");

    const pdfUrl = URL.createObjectURL(pdfBlob);

    document.body.removeChild(iframe);

    return {
        pdfBlob,
        pdfUrl
    };

};